import { classMerge } from '@components/utilities/classMerge'
import type { ColorGroup } from '@lib/colors/colors'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import getPreferredTrialTitle from '@modules/trials/helpers/getPreferredTrialTitle'
import type { UtmLookup } from '@prisma/client'
import { ApplyToTrialButton } from '../Button/ApplyToTrial/index.client'
import { ShareTrialButton } from '../Button/ShareTrialButton/index.client'
import { type LegacyTrialPageProps } from './getLegacyTrialListingPageProps'

export function TrialNavBarMenu({
  ctaColor,
  isHeroInView,
  shareTrialCodes,
  trial,
}: {
  ctaColor: ColorGroup
  isHeroInView: boolean
  shareTrialCodes: UtmLookup[]
  trial: LegacyTrialPageProps['trial']
}) {
  return (
    <div className='flex h-16 w-full flex-row items-center justify-start gap-4 p-2'>
      <ShareTrialButton
        className={classMerge('w-40', isHeroInView ? 'hidden' : 'visible')}
        color={'white'}
        shareTrialCodes={shareTrialCodes}
        trialSlug={trial.slug!}
        trialTitle={getPreferredTrialTitle(trial)}
      />
      <ApplyToTrialButton
        className={classMerge('w-40', isHeroInView ? 'hidden' : 'visible')}
        color={ctaColor}
        source={TrackingSources.NAVBAR}
        trial={trial}
      />
    </div>
  )
}
